import { Box } from 'components/Box/Box';
import { PrintHidden } from 'components/PrintHidden/PrintHidden';
import { SearchContextHeader } from 'modules/search/components/Context/SearchContextHeader';
import type { SearchContextHeaderData } from 'modules/search/containers/SearchContextHeader/SearchContextHeaderData';

type Props = {
  searchContext: SearchContextHeaderData;
};

export function ListingViewHeaderSearchContext({ searchContext }: Props) {
  return (
    <PrintHidden>
      <Box mb={[4, 4, 4, '40px']}>
        <SearchContextHeader searchContext={searchContext} />
      </Box>
    </PrintHidden>
  );
}
